import { BarChart3Icon } from 'lucide-react';

interface ConversationStatsProps {
  messageStats: Record<string, number>;
  totalMessages: number;
  filteredCount: number;
}

export const ConversationStats = ({
  messageStats,
  totalMessages,
  filteredCount,
}: ConversationStatsProps) => {
  const getMessageTypeLabel = (type: string) => {
    switch (type) {
      case 'sms':
        return 'SMS';
      case 'mms':
        return 'MMS';
      case 'email':
        return 'Email';
      case 'phone_call':
      case 'call':
        return 'Call';
      case 'front_chat':
        return 'Chat';
      default:
        return type.toUpperCase();
    }
  };

  const getMessageTypeColor = (type: string) => {
    switch (type) {
      case 'sms':
        return 'bg-green-100 text-green-800';
      case 'mms':
        return 'bg-blue-100 text-blue-800';
      case 'email':
        return 'bg-purple-100 text-purple-800';
      case 'phone_call':
      case 'call':
        return 'bg-orange-100 text-orange-800';
      case 'front_chat':
        return 'bg-indigo-100 text-indigo-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const statEntries = Object.entries(messageStats).sort(
    ([, a], [, b]) => b - a,
  );

  if (totalMessages === 0) {
    return null;
  }

  return (
    <div className="px-5 py-3 border-b border-gray-100 bg-white">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <BarChart3Icon className="h-4 w-4 text-gray-500" />
          <span className="text-sm font-medium text-gray-700">
            {filteredCount < totalMessages
              ? `${filteredCount} of ${totalMessages} messages`
              : `${totalMessages} messages`}
          </span>
        </div>

        {statEntries.length > 0 && (
          <div className="flex items-center gap-2">
            {statEntries.slice(0, 4).map(([type, count]) => (
              <span
                key={type}
                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getMessageTypeColor(type)}`}
              >
                {getMessageTypeLabel(type)} {count}
              </span>
            ))}
            {statEntries.length > 4 && (
              <span className="text-xs text-gray-500">
                +{statEntries.length - 4} more
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
